import * as React from 'react'
import type { SVGProps } from 'react'
function Icon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 229 244.4"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="c">
        <g>
          <path
            d="M179.2,38.2c-3.4,0-6.7,0.3-10,1C156.4,15,131.5,0,104.1,0C65.7,0,33.9,29.3,30.5,67.2C13.3,69.6,0,84.4,0,102.3
			c0,18.9,14.8,34.4,33.6,35.4c0.1,0,0.1,0,0.2,0c1.9,0,3.4-1.5,3.5-3.3c0.1-1.9-1.4-3.6-3.3-3.7c-15.1-0.8-27-13.2-27-28.4
			c0-15.7,12.8-28.5,28.5-28.5c3.9,0,7.8,0.8,11.4,2.4c5,2.2,9.2,5.7,12.2,10.2c1.1,1.6,3.3,2,4.9,0.9c1.6-1.1,2-3.3,0.9-4.9
			c-3.8-5.6-9.1-10-15.3-12.7c-3.8-1.7-7.9-2.6-12-2.9C41.1,33,69.6,7,104.1,7c24.3,0,46.4,13,58.3,34.1c-4.3,1.6-8.5,3.7-12.3,6.5
			c-7.5,5.4-13.3,12.8-16.9,21.4c-0.7,1.8,0.1,3.8,1.9,4.6c1.8,0.7,3.8-0.1,4.6-1.9c3-7.3,8-13.7,14.5-18.4c7.3-5.3,16-8.1,25.1-8.1
			c23.6,0,42.8,19.2,42.8,42.8s-19.2,42.8-42.8,42.8H96.4c-1.9,0-3.5,1.6-3.5,3.5s1.6,3.5,3.5,3.5h82.9c27.4,0,49.8-22.3,49.8-49.8
			S206.7,38.2,179.2,38.2z"
          />
        </g>
        <g>
          <path
            d="M165.3,212.9h-28l-14-24.3l14-24.3h28l14,24.3L165.3,212.9z M141.3,205.9h19.9l10-17.3l-10-17.3h-19.9l-10,17.3
			L141.3,205.9z"
          />
        </g>
        <g>
          <path
            d="M106.2,244.4H86.4l-9.9-17.1l9.9-17.1h19.7l9.9,17.1L106.2,244.4z M90.5,237.4h11.7l5.8-10.1l-5.8-10.1H90.5l-5.8,10.1
			L90.5,237.4z"
          />
        </g>
        <g>
          <path d="M79.6,176.8h-28l-14-24.3l14-24.3h28l14,24.3L79.6,176.8z M55.6,169.8h19.9l10-17.3l-10-17.3H55.6l-10,17.3L55.6,169.8z" />
        </g>
      </g>
    </svg>
  )
}
export default Icon
